// extracted by mini-css-extract-plugin
export default {"layoutWrapper":"loginLayout_layoutWrapper__CdJL-"};